import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import {getSourcingManagerDetails} from "../../reduxStore/action/sourcingManagerAction"
import { useDispatch, useSelector } from "react-redux";
import {
  getFileExtension,
  handleDetailResponse,
  isEmpty,
  seo,
} from "utils/utils";
import {
    genderCheck,
  } from "utils/constants";
import Breadcrumb from "component/common/breadcrumb";
import { userPasswordGenrate } from "reduxStore/action/usersActions";
import usePermission from "utils/usePermission";
import moment from "moment";
import ImageRender from "component/common/ImageRender";
import PdfViewer from "../../component/common/pdfViewer";

const SourcingManagerDetails = () => {
  const navigate = useNavigate();
  const [viewData, setViewData] = useState({});
  const dispatch = useDispatch();
  const params = useParams();
  const { _id = "" } = params || {};
  const { edit } = usePermission({
    edit: "edit_channelpartner",
  });

  const sourcingManagerDetailSelector = useSelector((state) => state.smData) 

  useEffect(() => {
    dispatch(getSourcingManagerDetails({ user_id: _id }));
  }, [_id, dispatch]);

  const getAge = (dobString) => {
    // Parse the date string into a Date object, assuming 'dd/mm/yyyy' format
    const dob = new Date(dobString.split('/').reverse().join('-')); 
  
    // Get the current date
    const currentDate = new Date();
  
    // Calculate the age
    let age = currentDate.getFullYear() - dob.getFullYear();
    const m = currentDate.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && currentDate.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  };

  useEffect(() => {
    if (sourcingManagerDetailSelector.detail) {
      const { response } = sourcingManagerDetailSelector;
      if (response?.status === 200) {
        setViewData(handleDetailResponse(response.data));
      }
    }
  }, [sourcingManagerDetailSelector]);



 
  return  (
    <div className="page-body">
    <Breadcrumb
      title={strings.smDetails}
      url={"/sourcing_managers"}
      parentListing={strings.sourcingManagerListing}
      titleactive={strings.viewSourcingManager}
      isBackBtn={true}
    />
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 card">
          <div className="row">
            <div className="col-md-12">
              <div className="card-header row justify-content-sm-between">
                <h5>{strings.smDetails}</h5>
              </div>
              <div className="card-body">
                <div className="tabbed-card">
                  <ul
                    className="nav nav-pills nav-primary"
                    id="pills-clrtabinfo"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="pills-clrprofile-tabinfo"
                        data-toggle="pill"
                        href="#pills-clrprofileinfo"
                        role="tab"
                        aria-controls="pills-clrprofile"
                        aria-selected="false"
                      >
                        {strings.stats}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="pills-clrhome-tabinfo"
                        data-toggle="pill"
                        href="#pills-clrhomeinfo"
                        role="tab"
                        aria-controls="pills-clrhome"
                        aria-selected="true"
                      >
                        {strings.smInfo}
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="pills-clrtabContentinfo">
                  
                         <div
                      className="tab-pane fade show active"
                      id="pills-clrprofileinfo"
                      role="tabpanel"
                      aria-labelledby="pills-clrprofile-tabinfo"
                    >
                      <div className="row">
                        <div className="col-md-4 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.totalVisits} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.user_states?.total_visit || 0}
                          </label>
                        </div>
                      </div>
                 
                      <hr />
                      <div className="row">
                        <div className="col-md-4 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.totalSiteVisit} :
                          </label>
                        </div>

                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.user_states?.total_site_visit ||
                              0}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.totalBooking} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.user_states?.total_closing_lead || 0}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.conversionPercentage} :
                          </label>
                        </div>

                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.user_states?.total_closing_percentage}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.lastLogin} :
                          </label>
                        </div>

                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.user_states?.last_login
                              ? moment(
                                viewData?.user_states?.last_login
                              ).format("DD-MM-yyyy hh:mm a")
                              : strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.lastLeadCreate} :
                          </label>
                        </div>

                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.user_states?.last_visit
                              ? moment(
                                viewData?.user_states?.last_visit
                              ).format("DD-MM-yyyy hh:mm a")
                              : strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.lastSiteVisit} :
                          </label>
                        </div>

                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.user_states?.last_site_visit
                              ? moment(
                                viewData?.user_states?.last_site_visit
                              ).format("DD-MM-yyyy hh:mm a")
                              : strings.notavailable
                              }
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-4 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.lastCloseVisit} :
                          </label>
                        </div>

                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.user_states?.last_sourcing_lead
                              ? moment(
                                viewData?.user_states
                                  ?.last_sourcing_lead
                              ).format("DD-MM-yyyy hh:mm a")
                              : strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-clrhomeinfo"
                      role="tabpanel"
                      aria-labelledby="pills-clrhome-tabinfo"
                    >
                      <div className="row">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.fullName} :
                          </label>
                        </div>

                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                            style={{ textTransform: "capitalize" }}
                          >
                            {viewData?.user_name || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.mobileNo} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.mobile || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.createdDate} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.createdDate
                              ? moment(viewData?.createdDate).format(
                                "DD-MM-yyyy hh:mm a"
                              )
                              : strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.emailAddress} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.email || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                     
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.aadharNo} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.adhar_no || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.pancardNo} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.pancard_no ||
                              strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.gender} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {genderCheck[viewData?.gender] ||
                              strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.age} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.dateofbirth
                              ? getAge(viewData?.dateofbirth)
                              : strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.parentname} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                            style={{ textTransform: "capitalize" }}
                          >
                            {viewData?.parent_name ||
                              strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.role} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.role_title ||
                              strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.city} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.city || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.address} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                            style={{ textTransform: "capitalize" }}
                          >
                            {viewData?.address || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.area} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.area || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      {/* <div className="row">
                        <div className="col-md-3 align-items-center mt-2">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.projectsName} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center mt-2">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.allocated_property &&
                              viewData?.allocated_property.length > 0 ? (
                              <div>
                                <label
                                  htmlFor="exampleInputMobileNo"
                                  className="boldText"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  {viewData?.allocated_property
                                    ?.map((item) => item?.property_title)
                                    .join(", ")}
                                </label>
                              </div>
                            ) : (
                              strings.notavailable
                            )}
                          </label>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};
export default SourcingManagerDetails;
